"use strict";

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isAbn = function isAbn(message) {
  return function (_ref) {
    var field = _ref.field;
    var value = field.value; // If ABN is false return undefined

    if (!value) {
      return true;
    } // Remove spaces if there's space in the inputted value


    value = value.split(' ').join(''); // The Australian Business Number (ABN) is a unique 11 digit identifier issued to all entities registered in the Australian Business Register (ABR).

    var digits = value.toString().split('');

    if (digits.length !== 11) {
      return [false, message];
    } // To verify an ABN:
    // 1 - Subtract 1 from the first (left-most) digit of the ABN to give a new 11 digit number


    digits[0] -= 1; // 2 - Multiply each of the digits in this new number by a "weighting factor" based on its position as shown in the table below

    var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

    for (var i = 0; i < 11; i++) {
      digits[i] = digits[i] * weight[i];
    } // 3 - Sum the resulting 11 products
    // 4 - Divide the sum total by 89, noting the remainder
    // 5 - If the remainder is zero the number is a valid ABN


    return [digits.reduce(function (a, b) {
      return a + b;
    }, 0) % 89 === 0, message];
  };
};

var _default = isAbn;
exports.default = _default;
//# sourceMappingURL=isAbn.js.map